<template>
	<v-navigation-drawer
		v-model="displayMenu"
		temporary
		absolute
		width="300"
		id="drawer"
		class="mobile-menu"
	>
		<v-container class="pa-4">
			<v-row v-if="!isAuth" class="justify-space-between">
				<div class="d-flex">
					<svg
						width="21"
						@click="() => (this.expandSearch = !this.expandSearch)"
						class="app-top-bar__search-icon mr-4"
						height="21"
						viewBox="0 0 21 21"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M9.22868 16.1497C10.1376 16.1497 11.0376 15.9707 11.8773 15.6229C12.717 15.2751 13.4799 14.7653 14.1226 14.1226C14.7653 13.4799 15.2751 12.7169 15.6229 11.8772C15.9707 11.0375 16.1497 10.1376 16.1497 9.22867C16.1497 8.31978 15.9707 7.41979 15.6229 6.58009C15.2751 5.74039 14.7653 4.97742 14.1226 4.33474C13.4799 3.69206 12.717 3.18225 11.8773 2.83444C11.0376 2.48662 10.1376 2.3076 9.22868 2.3076C7.39309 2.3076 5.63269 3.03678 4.33474 4.33474C3.03679 5.63269 2.3076 7.39309 2.3076 9.22867C2.3076 11.0642 3.03679 12.8246 4.33474 14.1226C5.63269 15.4206 7.39309 16.1497 9.22868 16.1497ZM16.5189 14.8878L20.6484 19.0174C20.7585 19.1238 20.8463 19.2512 20.9067 19.392C20.967 19.5327 20.9987 19.6841 21 19.8373C21.0012 19.9905 20.9719 20.1423 20.9138 20.284C20.8557 20.4258 20.7699 20.5545 20.6616 20.6627C20.5532 20.771 20.4243 20.8565 20.2825 20.9144C20.1407 20.9723 19.9888 21.0014 19.8357 21C19.6825 20.9985 19.5312 20.9666 19.3905 20.906C19.2498 20.8455 19.1226 20.7575 19.0162 20.6473L14.8867 16.5177C13.0323 17.9571 10.6992 18.6357 8.36211 18.4155C6.02504 18.1952 3.85978 17.0925 2.30709 15.332C0.754397 13.5714 -0.0689939 11.2853 0.00453217 8.93905C0.0780583 6.59278 1.04297 4.36272 2.70285 2.70285C4.36273 1.04297 6.59279 0.0780582 8.93906 0.00453216C11.2853 -0.0689939 13.5714 0.754396 15.332 2.30708C17.0925 3.85977 18.1952 6.02504 18.4155 8.3621C18.6358 10.6992 17.9571 13.0323 16.5177 14.8866L16.5189 14.8878Z"
							fill="#B9B9B9"
						/>
					</svg>
					<div
						:class="[
							expandSearch
								? 'app-top-bar__search-expanded'
								: 'app-top-bar__search-hidden',
						]"
					>
						<input
							type="text"
							class="app-top-bar__search-input"
							placeholder="Search"
							@input="searchHandler"
							v-model="searchValue"
						/>
					</div>
				</div>
				<div class="d-flex">
					<v-btn color="#DB7842" class="app-top-bar__login rounded-pill" to="/auth">
						<v-icon class="pr-2" color="white">mdi-login-variant</v-icon>
						Login
					</v-btn>
				</div>
			</v-row>
			<div v-else>
				<v-row>
					<v-col cols="12">
						<v-list-item-group
							class="d-flex justify-start pt-0 pl-4"
							active-class="app-top-bar__navigation-active"
							v-ripple="true"
							link
						>
							<div class="d-flex align-center">
								<svg
									width="21"
									@click="() => (this.expandSearch = !this.expandSearch)"
									class="app-top-bar__search-icon"
									height="21"
									viewBox="0 0 21 21"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M9.22868 16.1497C10.1376 16.1497 11.0376 15.9707 11.8773 15.6229C12.717 15.2751 13.4799 14.7653 14.1226 14.1226C14.7653 13.4799 15.2751 12.7169 15.6229 11.8772C15.9707 11.0375 16.1497 10.1376 16.1497 9.22867C16.1497 8.31978 15.9707 7.41979 15.6229 6.58009C15.2751 5.74039 14.7653 4.97742 14.1226 4.33474C13.4799 3.69206 12.717 3.18225 11.8773 2.83444C11.0376 2.48662 10.1376 2.3076 9.22868 2.3076C7.39309 2.3076 5.63269 3.03678 4.33474 4.33474C3.03679 5.63269 2.3076 7.39309 2.3076 9.22867C2.3076 11.0642 3.03679 12.8246 4.33474 14.1226C5.63269 15.4206 7.39309 16.1497 9.22868 16.1497ZM16.5189 14.8878L20.6484 19.0174C20.7585 19.1238 20.8463 19.2512 20.9067 19.392C20.967 19.5327 20.9987 19.6841 21 19.8373C21.0012 19.9905 20.9719 20.1423 20.9138 20.284C20.8557 20.4258 20.7699 20.5545 20.6616 20.6627C20.5532 20.771 20.4243 20.8565 20.2825 20.9144C20.1407 20.9723 19.9888 21.0014 19.8357 21C19.6825 20.9985 19.5312 20.9666 19.3905 20.906C19.2498 20.8455 19.1226 20.7575 19.0162 20.6473L14.8867 16.5177C13.0323 17.9571 10.6992 18.6357 8.36211 18.4155C6.02504 18.1952 3.85978 17.0925 2.30709 15.332C0.754397 13.5714 -0.0689939 11.2853 0.00453217 8.93905C0.0780583 6.59278 1.04297 4.36272 2.70285 2.70285C4.36273 1.04297 6.59279 0.0780582 8.93906 0.00453216C11.2853 -0.0689939 13.5714 0.754396 15.332 2.30708C17.0925 3.85977 18.1952 6.02504 18.4155 8.3621C18.6358 10.6992 17.9571 13.0323 16.5177 14.8866L16.5189 14.8878Z"
										fill="#B9B9B9"
									/>
								</svg>
								<div
									:class="[
										expandSearch
											? 'app-top-bar__search-expanded pl-4'
											: 'app-top-bar__search-hidden',
									]"
								>
									<input
										type="text"
										class="app-top-bar__search-input"
										placeholder="Search"
										@input="searchHandler"
										v-model="searchValue"
									/>
								</div>
							</div>
							<v-list-item v-ripple="false" class="flex-shrink-0 flex-grow-0">
								<v-list-item
									v-ripple="false"
									class="justify-center pa-0 mr-4 map-icon"
									to="/map"
								>
									<svg
										width="16"
										height="21"
										viewBox="0 0 16 21"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M6.98103 19.5927C7.26219 19.858 7.62647 20 8 20C8.37304 20 8.73588 19.8585 9.0161 19.5961L9.01611 19.5961L9.01994 19.5925C9.15855 19.4614 10.6273 18.0572 12.0685 16.0271C13.487 14.029 15 11.2581 15 8.42104C15 4.39268 11.923 1 8 1C4.077 1 1 4.39268 1 8.42104C1 11.2581 2.51295 14.029 3.93152 16.0271C5.3719 18.0559 6.83988 19.4596 6.98103 19.5927ZM6.98103 19.5927L7.66733 18.8654M6.98103 19.5927C6.9811 19.5928 6.98117 19.5929 6.98123 19.5929L7.66733 18.8654M7.66733 18.8654C7.76267 18.9554 7.88133 19 8 19C8.11867 19 8.23733 18.9554 8.33267 18.8661L7.66733 18.8654ZM8 10.9167C6.77053 10.9167 5.66667 9.83357 5.66667 8.375C5.66667 6.91643 6.77053 5.83333 8 5.83333C9.22947 5.83333 10.3333 6.91643 10.3333 8.375C10.3333 9.83357 9.22947 10.9167 8 10.9167Z"
											stroke-width="2"
										/>
									</svg>
								</v-list-item>

								<v-list-item
									v-ripple="false"
									class="justify-center pa-0 mr-4"
									to="/notifications"
								>
									<svg
										width="19"
										height="21"
										viewBox="0 0 19 21"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M18.5025 13.8672L16.6006 11.9669V7.28414C16.6259 5.54526 16.0172 3.856 14.8869 2.52828C13.7565 1.20056 12.1809 0.324044 10.451 0.0605782C9.44697 -0.0708034 8.42631 0.0120868 7.4571 0.303718C6.4879 0.595349 5.59242 1.08901 4.83043 1.75178C4.06845 2.41454 3.45746 3.23115 3.03826 4.14714C2.61905 5.06312 2.40125 6.05741 2.3994 7.06365V11.9669L0.49746 13.8672C0.258561 14.1086 0.0965546 14.4145 0.0316949 14.7469C-0.0331649 15.0792 0.00199917 15.4232 0.132791 15.7358C0.263583 16.0483 0.4842 16.3157 0.767061 16.5044C1.04992 16.693 1.38248 16.7947 1.72316 16.7966H5.27345V17.1535C5.32281 18.2194 5.79538 19.2224 6.58762 19.9427C7.37986 20.663 8.42715 21.0419 9.5 20.9963C10.5729 21.0419 11.6201 20.663 12.4124 19.9427C13.2046 19.2224 13.6772 18.2194 13.7265 17.1535V16.7966H17.2768C17.6175 16.7947 17.9501 16.693 18.2329 16.5044C18.5158 16.3157 18.7364 16.0483 18.8672 15.7358C18.998 15.4232 19.0332 15.0792 18.9683 14.7469C18.9034 14.4145 18.7414 14.1086 18.5025 13.8672ZM11.6133 17.1535C11.5547 17.6586 11.3022 18.1216 10.9086 18.4463C10.5149 18.771 10.0103 18.9322 9.5 18.8964C8.98966 18.9322 8.4851 18.771 8.09143 18.4463C7.69775 18.1216 7.44533 17.6586 7.38673 17.1535V16.7966H11.6133V17.1535ZM2.64243 14.6967L3.88926 13.4578C4.08703 13.2624 4.24393 13.0301 4.35093 12.7742C4.45793 12.5183 4.5129 12.2439 4.51268 11.9669V7.06365C4.51325 6.35537 4.66629 5.6554 4.96153 5.01072C5.25676 4.36605 5.68736 3.79158 6.22443 3.32588C6.75424 2.84888 7.38205 2.49197 8.06439 2.27986C8.74673 2.06776 9.46731 2.00552 10.1762 2.09746C11.3982 2.29461 12.5074 2.92377 13.2996 3.8691C14.0917 4.81443 14.5135 6.01229 14.4873 7.24214V11.9669C14.4857 12.2432 14.539 12.5172 14.6442 12.773C14.7494 13.0289 14.9043 13.2616 15.1002 13.4578L16.3576 14.6967H2.64243Z"
										/>
									</svg>
								</v-list-item>

								<v-list-item
									v-ripple="false"
									class="justify-center pa-0 mr-4"
									to="/mymuseum/chat"
								>
									<svg
										width="22"
										height="22"
										viewBox="0 0 22 22"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M2.06676 21.1051L2.06679 21.1051L6.00504 19.8369C7.5246 20.6973 9.24218 21.15 11 21.15C16.6096 21.15 21.15 16.6103 21.15 11C21.15 5.39043 16.6103 0.85 11 0.85C5.39043 0.85 0.85 5.38965 0.85 11C0.85 12.7578 1.30272 14.4754 2.1631 15.995L0.894917 19.9332C0.78778 20.2657 0.875822 20.6302 1.12282 20.8772C1.36742 21.1218 1.731 21.2131 2.06676 21.1051ZM6.61343 18.0319L6.6134 18.0319C6.38409 17.8886 6.0993 17.8498 5.83426 17.9352L5.83424 17.9352L3.22433 18.7757L4.06484 16.1658L4.06485 16.1657C4.14889 15.9045 4.11341 15.6194 3.96793 15.3866L3.96792 15.3866C3.14671 14.0731 2.7125 12.5563 2.7125 11C2.7125 6.43044 6.43044 2.7125 11 2.7125C15.5696 2.7125 19.2875 6.43044 19.2875 11C19.2875 15.5696 15.5696 19.2875 11 19.2875C9.44367 19.2875 7.92691 18.8533 6.61343 18.0319ZM11 12.1266C11.6223 12.1266 12.1266 11.6221 12.1266 11C12.1266 10.3778 11.6222 9.87344 11 9.87344C10.3778 9.87344 9.87344 10.3778 9.87344 11C9.87344 11.6221 10.3777 12.1266 11 12.1266ZM14.9062 12.1266C15.5285 12.1266 16.0328 11.6221 16.0328 11C16.0328 10.3778 15.5285 9.87344 14.9062 9.87344C14.284 9.87344 13.7797 10.3778 13.7797 11C13.7797 11.6221 14.284 12.1266 14.9062 12.1266ZM7.09375 12.1266C7.71601 12.1266 8.22031 11.6221 8.22031 11C8.22031 10.3778 7.71599 9.87344 7.09375 9.87344C6.47168 9.87344 5.96719 10.3777 5.96719 11C5.96719 11.6221 6.47166 12.1266 7.09375 12.1266Z"
											stroke-width="0.3"
										/>
									</svg>
								</v-list-item>

								<v-list-item
									v-ripple="false"
									class="justify-center pa-0 mr-4"
									to="/post/create"
								>
									<svg
										width="22"
										height="22"
										viewBox="0 0 22 22"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M12.0078 12.008L20.5745 12.0079C21.1319 12.008 21.5823 11.5575 21.5822 11.0001C21.5822 10.4429 21.1317 9.99242 20.5745 9.99242L12.0077 9.99242L12.0078 1.42575C12.0077 0.86838 11.5573 0.418024 11.0001 0.418024C10.4427 0.417893 9.99225 0.868379 9.99238 1.42574L9.99225 9.99242L1.42558 9.99254C0.868216 9.99241 0.41773 10.4429 0.417861 11.0003C0.41773 11.2781 0.530482 11.5305 0.712922 11.7129C0.895361 11.8954 1.14762 12.008 1.42558 12.008L9.99225 12.0079L9.99226 20.5747C9.99226 20.8526 10.1049 21.1049 10.2873 21.2873C10.4698 21.4698 10.722 21.5824 11 21.5824C11.5573 21.5825 12.0078 21.132 12.0077 20.5747L12.0078 12.008Z"
										/>
									</svg>
								</v-list-item>
							</v-list-item>
						</v-list-item-group>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" class="pt-0">
						<v-list-item-group
							active-class="mobile-active"
							class="pa-0 d-flex flex-column"
							dense
						>
							<v-list-item v-ripple="false">
								<v-list-item-avatar size="41">
									<img
										referrerpolicy="no-referrer"
										:src="userAvatar"
										alt="avatar"
									/>
								</v-list-item-avatar>
							</v-list-item>
							<v-list-item
								active-class="app-tob-bar__active-profile"
								v-for="item in profileSettings"
								:key="item.title"
								link
								:to="item.path"
								class="d-inline-block"
							>
								<v-list-item-content
									class="app-top-bar__link-content d-inline-block pb-0"
								>
									<v-list-item-title
										@click="item.action"
										class="d-inline-block"
										>{{ item.name }}</v-list-item-title
									>
								</v-list-item-content>
							</v-list-item>
							<v-list-item v-for="category in categories" :key="category.id" link>
								<v-list-item-content class="d-inline-block">
									<v-list-item-title
										class="d-inline-block"
										@click="
											categoryHandler(category.id)
											drawer = false
										"
									>
										{{ category.name }}
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-item-group>
					</v-col>
				</v-row>
			</div>
		</v-container>
	</v-navigation-drawer>
</template>

<script>
import magnifyIcon from '@/assets/images/search.svg'

export default {
	name: 'MobileMenu',
	data() {
		return {
			magnifyIconSrc: magnifyIcon,
			searchValue: '',
			expandSearch: false,
		}
	},
	props: {
		isAuth: {
			type: Boolean,
			default: false,
		},
		profileSettings: {
			type: Array,
			default: () => [],
		},
		categories: {
			type: Array,
			default: () => [],
		},
		userAvatar: {
			type: String,
			default: null,
		},
		displayMenu: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		searchHandler() {
			this.$eventBus.$emit('search', this.searchValue)
		},
		categoryHandler(id) {
			if (this.$route.name !== 'Home') {
				this.$router.push({ name: 'Home' })
			}

			this.$eventBus.$emit('load-posts-by-category', id)
			this.category = id
			this.$emit('nav-change', {
				category: this.category,
			})
		},
	},
}
</script>

<style lang="scss">
.mobile-menu {
	.v-list-item {
		flex: 0;

		&__title {
			font-size: 15px !important;
			font-family: 'Montserrat';
			letter-spacing: 0.015em !important;
			color: rgba(32, 34, 50, 0.85) !important;
			font-weight: 800 !important;
			padding-bottom: 5px;
		}

		&:hover .v-list-item__title {
			color: #db7842 !important;
		}
	}
	.mobile-active .v-list-item__title {
		border-bottom: 2px solid #db7842;
	}
}
</style>
